module.exports = __webpack_public_path__ + "img/road-closed.b3b5dead.svg";